/* unplugin-vue-components disabled */import { render } from "./TaiChiARender.vue?vue&type=template&id=daadd74a&scoped=true"
import script from "./TaiChiARender.vue?vue&type=script&lang=js"
export * from "./TaiChiARender.vue?vue&type=script&lang=js"

import "./TaiChiARender.vue?vue&type=style&index=0&id=daadd74a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daadd74a"]])

export default __exports__